import "./header.scss";

import React, { FC, useState, useRef, useEffect } from "react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { useWallet } from "@solana/wallet-adapter-react";
import { Link } from "react-router-dom";

import { FaTwitter } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";
import { TfiClose } from "react-icons/tfi";

interface FooterProps {}

const Header: FC<FooterProps> = () => {
  const sidebarRef = useRef();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleSidebarButton = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleClickOverlay = (event: any) => {
    // @ts-ignore
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setSidebarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOverlay, true);
    return () => {
      document.removeEventListener("click", handleClickOverlay, true);
    };
  }, []);

  const { publicKey } = useWallet();
  return (
    <div className="relative" style={{ background: "black" }}>
      <header className="header">
        <Link to={`/`} className="logo">
          <div>
            <img src={require("../../assets/images/draco-coin-logo.png")} />
          </div>
        </Link>
        <div className="center">
          <div
            style={{ color: "white" }}
            className="text-black text-center text-5xl font-bold font-bold font-sans"
          >
            WHITELIST
          </div>
        </div>

        <div className="right">
          {/*<button type="button" style={{background: '#1f82e2'}} className="wallet text-white font-medium text-sm px-5 py-2.5">CONNECT WALLET</button>*/}
          <div className="basis-1/4">
            <WalletMultiButton
              style={{
                background: "white",
                color: "black",
                fontFamily: "Draco2",
              }}
              className="wallet text-white font-medium text-sm px-5 py-2.5"
            />
          </div>

          <button
            type="button"
            className="font-medium text-lg menu-btn"
            onClick={handleSidebarButton}
          >
            <svg
              className="fill-white"
              width="22"
              height="18"
              viewBox="0 0 22 18"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 1C0 0.447715 0.447715 0 1 0H21C21.5523 0 22 0.447715 22 1C22 1.55228 21.5523 2 21 2H1C0.447715 2 0 1.55228 0 1ZM0 9C0 8.44772 0.447715 8 1 8H21C21.5523 8 22 8.44772 22 9C22 9.55229 21.5523 10 21 10H1C0.447715 10 0 9.55229 0 9ZM0 17C0 16.4477 0.447715 16 1 16H21C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H1C0.447715 18 0 17.5523 0 17Z"
              ></path>
            </svg>
          </button>
        </div>
      </header>

      <section className={`overlay ${sidebarOpen ? "block" : "hidden"}`}>
        <aside
          // @ts-ignore
          ref={sidebarRef}
          className={`sidebar fixed z-40 w-96 top-0  h-screen transition-all delay-300  ${
            sidebarOpen ? "right-0" : "right-999"
          }`}
          style={{
            boxShadow:
              "0 -8px 2px rgb(0 0 0 / 19%), 0 6px 43px rgb(0 0 0 / 23%)",
          }}
          aria-label="Sidebar"
        >
          <div
            className="absolute right-0 px-8 pt-4 close-btn cursor-pointer"
            onClick={() => setSidebarOpen(false)}
          >
            <TfiClose className="text-gray-900" size="1.5em" />
          </div>
          <div className="h-full bg-white px-4 pt-8">
            <div className="w-full sidebar-header flex font-bold text-xl justify-between p-6 mb-10">
              <div className="flex">
                <h1 style={{ color: "black", fontSize: "1.6rem" }}>
                  WHITELIST
                </h1>
              </div>
              <div className="flex flex-row align-middle">
                <Link
                  className="social-icons"
                  to="https://twitter.com/51DracoNFT"
                  target="_blank"
                >
                  <FaTwitter
                    className="social-icons"
                    style={{ marginRight: "15px", fontSize: "1.6rem" }}
                  />
                </Link>
                <Link
                  className="social-icons"
                  to="https://discord.gg/VSSNG4Cv85"
                  target="_blank"
                >
                  <FaDiscord
                    className="social-icons"
                    style={{ fontSize: "1.6rem" }}
                  />
                </Link>
              </div>
            </div>
            <div className="p-6 font-sans">
              <h1 className="mb-4 text-xl font-extrabold leading-none tracking-tight text-gray-900 md:text-xl lg:text-xl dark:text-white">
                <mark className="px-2 text-white bg-gray-900 rounded dark:bg-blue-500">
                  51 Draco
                </mark>
              </h1>
              <p
                style={{ color: "black", fontFamily: "Draco2" }}
                className="font-normal dark:text-gray-400"
              >
                Visit our official draco website
              </p>
              <Link
                style={{ fontFamily: "Draco2" }}
                className="external-link-color social-icons underline hover:text-blue-800 visited:text-purple-600"
                to="https://51draco.com/"
                target="_blank"
              >
                https://51draco.com
              </Link>
            </div>
            <div className="p-6 font-sans">
              <h1 className="mb-4 text-xl font-extrabold leading-none tracking-tight text-gray-900 md:text-xl lg:text-xl dark:text-white">
                <mark className="px-2 text-white bg-gray-900 rounded dark:bg-blue-500">
                  51 Blog
                </mark>
              </h1>
              <p
                style={{ color: "black", fontFamily: "Draco2" }}
                className="font-normal dark:text-gray-400"
              >
                Subscribe to receive our latest posts directly in your inbox
              </p>
              <Link
                style={{ fontFamily: "Draco2" }}
                className="external-link-color social-icons underline hover:text-blue-800 visited:text-purple-600"
                to="https://blog.51draco.com"
                target="_blank"
              >
                https://blog.51draco.com
              </Link>
            </div>
            <div className="p-6 font-sans">
              <h1 className="mb-4 text-xl font-extrabold leading-none tracking-tight text-gray-900 md:text-xl lg:text-xl dark:text-white">
                <mark className="px-2 text-white bg-gray-900 rounded dark:bg-blue-500">
                  Club 51
                </mark>
              </h1>
              <p
                style={{ color: "black", fontFamily: "Draco2" }}
                className="font-normal dark:text-gray-400"
              >
                Explore our exclusive merchandises and NFTs
              </p>
              <Link
                style={{ fontFamily: "Draco2" }}
                className="external-link-color social-icons underline hover:text-blue-800 visited:text-purple-600"
                to="https://club.51draco.com"
                target="_blank"
              >
                https://club.51draco.com
              </Link>
            </div>
          </div>
        </aside>
      </section>
    </div>
  );
};

export default Header;
